import { render, staticRenderFns } from "./AssignmentConfigEdit.vue?vue&type=template&id=faf9dd60"
import script from "./AssignmentConfigEdit.vue?vue&type=script&lang=js"
export * from "./AssignmentConfigEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports